export function doPolling(callback) {
  var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1000 : _ref$timeout,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 1000 : _ref$interval;

  var startTime = Date.now();
  var intervalId = setInterval(function () {
    if (condition()) {
      clearInterval(intervalId);
      callback();
      return;
    }

    if (Date.now() - startTime > timeout) {
      clearInterval(intervalId);
    }
  }, interval);
}